import api from '../api'
import { MaterialStock, QueryMaterialStock, QueryParamsListProduct } from './interface'

export const getListMaterialOrder = async (query: QueryParamsListProduct) => {
  const returnApi = await api
    .get(`produto/v2/ListMaterialPedido`, {
      params: query
    })
    .then((response) => response)
    .then((data) => data.data)
    .catch((err) => {
      console.error(err)
    })
  return returnApi
}

export const getMaterialStock = async (
  query: QueryMaterialStock,
  signal?: AbortSignal
) => {
  const response = await api.get<MaterialStock>(
    `/services/inventory-management/v1/materiais/volumes`,
    {
      params: query,
      signal
    }
  )

  return response.data
}
